var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !!_vm.$store.state.viewInfo.moduleSessionCollection
        ? _c(
            "div",
            { attrs: { role: "tablist" } },
            _vm._l(_vm.$store.state.viewInfo.moduleSessionCollection, function(
              moduleSessionItem,
              index_ms
            ) {
              return _c(
                "b-card",
                {
                  key: index_ms,
                  staticClass: "mb-1",
                  attrs: { "no-body": "" }
                },
                [
                  _c(
                    "b-card-header",
                    {
                      staticClass: "p-1",
                      attrs: { "header-tag": "header", role: "tab" }
                    },
                    [
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "viewInfoTab[" + index_ms + "]",
                              expression: "'viewInfoTab['+index_ms+']'"
                            }
                          ],
                          attrs: { block: "", variant: "outline-info" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                moduleSessionItem.moduleSession.moduleName
                              ) +
                              " |\n          Time: " +
                              _vm._s(
                                _vm
                                  .$moment(
                                    moduleSessionItem.moduleSession[
                                      "sessionTimeRaw"
                                    ],
                                    [
                                      "X",
                                      "DD/MM/YYYY HH:mm",
                                      "DD-MM-YYYY HH:mm",
                                      _vm.$moment.ISO_8601
                                    ]
                                  )
                                  .format("DD-MM-YYYY HH:mm")
                              ) +
                              " |\n          Room: " +
                              _vm._s(moduleSessionItem.moduleSession.roomId) +
                              " |\n          Seat-Left: " +
                              _vm._s(
                                moduleSessionItem.moduleSession.seatTotal -
                                  moduleSessionItem.moduleSession.seatTaken
                              ) +
                              "|\n          Seat-Taken: " +
                              _vm._s(
                                moduleSessionItem.moduleSession.seatTaken
                              ) +
                              "|\n          Language: " +
                              _vm._s(moduleSessionItem.moduleSession.language) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-collapse",
                    {
                      attrs: {
                        id: "viewInfoTab[" + index_ms + "]",
                        accordion: "my-accordion",
                        role: "tabpanel"
                      }
                    },
                    [
                      _c(
                        "b-card-body",
                        { attrs: { id: "content" + index_ms } },
                        [
                          _c("p", [
                            _c("strong", [_vm._v("Module Name: ")]),
                            _vm._v(
                              _vm._s(moduleSessionItem.moduleSession.moduleName)
                            )
                          ]),
                          _c("p", [
                            _c("strong", [_vm._v("Session Time: ")]),
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(
                                    moduleSessionItem.moduleSession[
                                      "sessionTimeRaw"
                                    ],
                                    [
                                      "DD/MM/YYYY HH:mm",
                                      "DD-MM-YYYY HH:mm",
                                      _vm.$moment.ISO_8601
                                    ]
                                  )
                                  .format("DD-MM-YYYY HH:mm")
                              )
                            )
                          ]),
                          _vm._l(
                            _vm.$store.state.viewInfo.userCollection,
                            function(msIdArr, msid_index) {
                              return _c("div", { key: "s" + msid_index }, [
                                msid_index == index_ms
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.$store.state.viewInfo
                                          .userCollection[msid_index],
                                        function(userArr, status_index, key) {
                                          return _c(
                                            "div",
                                            { key: "status" + status_index },
                                            [
                                              _c(
                                                "h3",
                                                { style: _vm.statusStyle },
                                                [_vm._v(_vm._s(status_index))]
                                              ),
                                              _c("b-table", {
                                                attrs: {
                                                  items: userArr,
                                                  fields: _vm.detailTableFields,
                                                  fixed: "",
                                                  bordered: "",
                                                  "sort-compare":
                                                    _vm.sortCompareAdvanced
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "count",
                                                    fn: function(row) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(row.index + 1)
                                                        )
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "action",
                                                    fn: function(row) {
                                                      return [
                                                        status_index ===
                                                          "pendingAttend" &&
                                                        _vm.$store.state
                                                          .authUser.flag ==
                                                          "Admin"
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "b-btn",
                                                                  {
                                                                    attrs: {
                                                                      block: "",
                                                                      variant:
                                                                        "danger"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.popRemoveModal(
                                                                          $event.target,
                                                                          row,
                                                                          msid_index,
                                                                          moduleSessionItem
                                                                            .moduleSession
                                                                            .sessionTimeRaw,
                                                                          msIdArr
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "CANCEL "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : status_index ===
                                                              "pendingAttend" &&
                                                            _vm
                                                              .$moment(
                                                                moduleSessionItem
                                                                  .moduleSession
                                                                  .sessionTimeRaw,
                                                                "DD/MM/YYYY"
                                                              )
                                                              .diff(
                                                                _vm.$moment(
                                                                  new Date(),
                                                                  "DD/MM/YYYY"
                                                                ),
                                                                "days"
                                                              ) >= 3 &&
                                                            _vm.$store.state
                                                              .authUser.flag ==
                                                              "Con"
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-btn",
                                                                    {
                                                                      attrs: {
                                                                        block:
                                                                          "",
                                                                        variant:
                                                                          "danger"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.popRemoveModal(
                                                                            $event.target,
                                                                            row,
                                                                            msid_index,
                                                                            moduleSessionItem
                                                                              .moduleSession
                                                                              .sessionTimeRaw,
                                                                            msIdArr
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "CANCEL "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _c("div"),
                                                        _vm.$store.state
                                                          .authUser.flag ==
                                                          "Admin" &&
                                                        (status_index ===
                                                          "presentPendingGrade" ||
                                                          status_index ===
                                                            "presentPass" ||
                                                          status_index ===
                                                            "presentFailed" ||
                                                          status_index ===
                                                            "Rejected" ||
                                                          status_index ===
                                                            "absent")
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "b-btn",
                                                                  {
                                                                    attrs: {
                                                                      block: "",
                                                                      variant:
                                                                        "danger"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.revertAttendance(
                                                                          $event.target,
                                                                          row,
                                                                          msid_index
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Revert"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm.$store.state
                                                              .authUser.flag ==
                                                              "Trn" &&
                                                            (status_index ===
                                                              "presentPendingGrade" ||
                                                              status_index ===
                                                                "presentPass" ||
                                                              status_index ===
                                                                "presentFailed" ||
                                                              status_index ===
                                                                "Rejected" ||
                                                              status_index ===
                                                                "absent")
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "b-btn",
                                                                    {
                                                                      attrs: {
                                                                        block:
                                                                          "",
                                                                        variant:
                                                                          "danger"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.revertAttendance(
                                                                            $event.target,
                                                                            row,
                                                                            msid_index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Revert"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm.$store.state
                                                                .authUser
                                                                .flag == "Con"
                                                              ? _c("div")
                                                              : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    )
                                  : _vm._e()
                              ])
                            }
                          )
                        ],
                        2
                      ),
                      _vm.$store.state.authUser.flag == "Admin"
                        ? _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.printContent("content" + index_ms)
                                }
                              }
                            },
                            [_vm._v("Print Session Details")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            })
          )
        : _c(
            "div",
            [
              _c(
                "b-card",
                {
                  staticClass: "text-center",
                  attrs: { "bg-variant": "warning" }
                },
                [
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("No module session found")
                  ])
                ]
              )
            ],
            1
          ),
      _c("p", [_vm._v("this is VIEW SESSION DETAILS OF DAY COMPONENT")]),
      _c(
        "b-modal",
        { attrs: { id: "cancelBookingModal", "hide-footer": "", size: "lg" } },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "Insert remark to cancel" },
                model: {
                  value: _vm.remarkInput,
                  callback: function($$v) {
                    _vm.remarkInput = $$v
                  },
                  expression: "remarkInput"
                }
              }),
              _c(
                "b-btn",
                {
                  staticClass: "mt-3",
                  attrs: {
                    size: "lg",
                    variant: "outline-danger",
                    block: "",
                    disabled: _vm.remarkInput == null
                  },
                  on: {
                    click: function($event) {
                      _vm.cancelBooking()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                              Confirm Cancel\n                            "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76e4058a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e4058a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/viewingInfo/ViewSessionDetailsOfDay.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-76e4058a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/viewingInfo/ViewSessionDetailsOfDay.vue
// module chunks = 2